var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',[(_vm.isPrivate)?_c('span',{staticClass:"tag is-danger"},[_vm._v(" "+_vm._s(_vm.location)+" ")]):_vm._e(),(!_vm.isPrivate)?_c('span',[_vm._v(" "+_vm._s(_vm.location)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }